import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationDialogDetail {
  label: string;
  value: string;
}

export class ConfirmationDialogModel {
  confirm: string
  cancel: string

  constructor(public title: string, public message: string, public confirmText?: string, public cancelText?: string, public details?: ConfirmationDialogDetail[]) {
  }
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

  title: string;
  message: string;
  details: ConfirmationDialogDetail[];

  confirm: string
  cancel: string

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogModel) {
    this.title = data.title;
    this.message = data.message;
    this.details = data.details;

    this.confirm = data.confirmText ? data.confirmText : "Yes";
    this.cancel = data.cancelText ? data.cancelText : "No";
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}
